import React from "react";
export class StarIcon extends React.Component {
    shouldComponentUpdate() {
        return false;
    }
    render() {
        const { active, className } = this.props;
        const fill = active ? "#C20000" : "#373435";
        return (<svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" className={className}>
				<path fill={fill} fillRule="nonzero" d="M7.687 4.912L7 2.696 6.31 4.92a1.735 1.735 0 0 1-1.652 1.223h-2.37L4.252 7.64a1.77 1.77 0 0 1 .617 1.933l-.724 2.337 1.813-1.381a1.719 1.719 0 0 1 2.085.001l1.81 1.38-.724-2.34a1.767 1.767 0 0 1 .612-1.926l1.97-1.502H9.345a1.74 1.74 0 0 1-1.657-1.23zm1.655.064h4.09a.558.558 0 0 1 .54.402.609.609 0 0 1-.203.665l-3.32 2.53a.603.603 0 0 0-.204.656l1.265 4.086a.624.624 0 0 1-.085.535.55.55 0 0 1-.792.122l-3.297-2.513a.552.552 0 0 0-.672 0l-3.297 2.513a.546.546 0 0 1-.792-.122.624.624 0 0 1-.085-.535L3.755 9.23a.603.603 0 0 0-.204-.656L.23 6.043a.609.609 0 0 1-.202-.665.558.558 0 0 1 .538-.402h4.091a.571.571 0 0 0 .541-.41L6.459.5A.575.575 0 0 1 7 .089c.244 0 .462.165.54.41l1.261 4.068a.571.571 0 0 0 .54.41z"/>
			</svg>);
    }
}
